'use client'

import React, { useEffect, useState } from 'react'
import Modal from "styleguide/components/Modal";
import ModalNewsletter from "styleguide/components/modal/Newsletter";
// import NewModalNewsletter from "styleguide/components/modal/NewsletterVariant";
import Sweepstakes from "styleguide/components/modal/Sweepstakes";
import ExitIntent from "styleguide/components/modal/ExitIntent";
import Close from 'styleguide/images/icons/close.svg';
import { useEventTracker } from '@/lib/analytic-events';
import { useCookie } from "react-use";
import { growthbook } from '@/lib/growthbook';

import {
	getCookie,
	setCookie,
} from '~/modules/utils';


const MODAL_NEWSLETTER = {
    src: 'https://cdn.shopify.com/s/files/1/0286/1327/9779/files/Rectangle_2241.png?v=1696414159',
    srcSet: 'https://cdn.shopify.com/s/files/1/0073/5186/1332/files/newsletter-bigger-mobile.png?v=1646639302',
    title: 'Join the club',
    subtitle: '& get a FREE hair wrap!',
    desc: 'Get a FREE hair wrap on your first order, plus first access to new product launches, exclusive offers, routines, and beauty tips.',
    tc: 'Receive exclusive offers via email or automated marketing SMS (4/mth). For more info see our Privacy Policy (opt out any time). Msg &amp; data rates may apply. Consent not required for purchase.'
};

const Modals = (props: any) => {
    const { exitIntentData } = props;
    const [store] = useCookie('region');
    const [isLoading, setIsLoading] = useState(true);
    const [isSweepstakesLoading, setIsSweepstakesLoading] = useState(true);
    const [modal2, toggleModal2] = useState(false);
    const [content, setContent] = useState(null);
    const [floatingShow, setFloatingShow] = useState(true);
    const [show, setShow] = useState(false);
    const [sweepstakesOpenModal, setSweepstakesOpenModal] = useState(false);
    const [sweepstakesContent, setSweeptakesContent] = useState(null);
    const [hasScrolled, setHasScrolled] = useState(false);
    const [exitIntentShow, setExitIntentShow] = useState(false);
    // const [newsletterRedesign, setNewsletterRedesign] = useState(false);
	const handlOpenModal2 = (open: boolean) => {
        setCookie('signup_popup', 'signup_popup', 30);
		toggleModal2(open);
        setShow(open);
	};

    const handlOpenIntent = (open: boolean) => {
        setExitIntentShow(open);
    }

    const mouseEvent = (e) => {
		const opened = getCookie('exitIntentShown');
		const shouldShowExitIntent = !e.toElement && !e.relatedTarget && e.clientY < 0;
		if (!opened && shouldShowExitIntent && !exitIntentShow) {
			document.removeEventListener('mouseout', mouseEvent);
			setExitIntentShow(true);
			setCookie('exitIntentShown', true, 30);
		}
	};

    const { trackBluecoreLaunchWaitlistEvent, trackEvent } = useEventTracker();

    const handleSweepstakesOpenModal = (open: boolean) => {
        setCookie('sweepstakes_signup_popup', 'sweepstakes_signup_popup', 30);
        setSweepstakesOpenModal(open);
    }

    const checkSweepstakesPopupShow = () => {
		if (getCookie('sweepstakes_signup_popup') !== 'sweepstakes_signup_popup') {
			setSweepstakesOpenModal(true);
		}
	};
    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 80 && !hasScrolled) {
                setHasScrolled(true);
                setShow(true);
                toggleModal2(true);
                window.removeEventListener("scroll", handleScroll);
            }
        };
        const nFurl = store === 'dev' ? `/api/getNewsletterForm?region=${store}&preview=staging}` : `/api/getNewsletterForm`
        fetch(nFurl).then(
            res => {
                res.json().then(data => {
                    const contentData = data?.body?.newsletterFormPopup?.newsletterFormPopup?.[store];
                    if (contentData?.nbp_enabled) {
                        setContent(contentData);
                        setIsLoading(false);
                        if (getCookie('signup_popup') !== 'signup_popup') {
                            if (contentData?.nbp_on_show === 'on-init') {
                                setShow(true);
                                toggleModal2(true);
                            } else if (contentData?.nbp_on_show === 'on-delay') {
                                setTimeout(() => {
                                    setShow(true);
                                    toggleModal2(true);
                                }, 5500)
                            } else if  (contentData?.nbp_on_show === 'on-movement') {
                                window.addEventListener("scroll", handleScroll);   
                            }
                        }
                    }
                })
            }
        );
        
        const url = store === 'dev' ? `/api/getSweepstakesForm?region=${store}&preview=${store === 'dev' ? 'staging' : ''}` : `/api/getSweepstakesForm?region=${store}`
        fetch(url).then(
            res => {
                res.json().then(data => {
                    if (data.status === 200 && data?.body?.sweepstakes_signup_popup) {
                        setSweeptakesContent(data?.body || null);
                        setIsSweepstakesLoading(false);
                    }
                });
            }
        );
        checkSweepstakesPopupShow();
        if (!exitIntentShow && 768 <= window.innerWidth && exitIntentData?.enable) {
			document.addEventListener('mouseout', mouseEvent);
		}
    }, [])

    const showNewsletterModal = !isSweepstakesLoading && sweepstakesContent && !sweepstakesContent.sweepstakes_signup_popup;

    return (
        <>
            {!isLoading && isSweepstakesLoading && store && (
                <>
                    {content.floating_btn && (
                        <button type="button" className={`flex btn text-white modal-newsletter--floating-btn fixed rounded-full px-g items-center border border-transparent ${!show && floatingShow ? `show ${props.productTemplate ? '!bottom-[5.625em]' : ''}` : ''}`}>
                            <span className="font-normal pr-1" onClick={() => handlOpenModal2(true)}>{content.floating_btn}</span>
                            <Close className="svg fill-white" onClick={() => setFloatingShow(false)} />
                        </button>
                    )}
                    <Modal className={`modal-lg modal-dialog-centered lg:min-w-[48.1875em]`} isOpen={modal2} handleClose={() => handlOpenModal2(false)} slideIn={content?.slide_in} modalComp="newsletter" >
                    <ModalNewsletter trackEvent={trackEvent} store={store} handleClose={() => handlOpenModal2(false)} data={content} />
                        {/* {newsletterRedesign && <NewModalNewsletter trackEvent={trackEvent} store={store} handleClose={() => handlOpenModal2(false)} data={content} />} */}
                    </Modal>
                </>
            )}
            {!isSweepstakesLoading && store && (
                <Modal className="modal-lg modal-dialog-centered lg:min-w-[45em]" isOpen={sweepstakesOpenModal} handleClose={() => handleSweepstakesOpenModal(false)} slideIn={content?.slide_in} modalComp="sweepstakes">
                    <Sweepstakes
                        store={store}
                        handleClose={() => handleSweepstakesOpenModal(false)}
                        data={sweepstakesContent}
                        trackBluecoreLaunchWaitlistEvent={trackBluecoreLaunchWaitlistEvent} />
                </Modal>
            )}

            {exitIntentData?.enable && (
                <Modal className="modal-lg modal-dialog-centered lg:max-w-[39.375rem]" isOpen={exitIntentShow} handleClose={() => handlOpenIntent(false)}>
                    <ExitIntent handleClose={() => handlOpenIntent(false)} data={exitIntentData} />
                </Modal>
            )}
        </>
    )
}

export default Modals;
